// money.ts — the single place the UI turns an amount into something a person reads.
//
// WHY: the euro sign used to be hardcoded across Cases, CaseFocus, Dashboard, Home,
// Inventory and SupplierDetail, so a USD customer saw "€466.29" on dollar invoices.
// The numbers were right; only the symbol was wrong — which is exactly the kind of
// detail that destroys trust in a product whose whole job is getting money right.
//
// Mirrors server/currency.js so a figure reads identically wherever it is rendered.

const CURRENCY_SYMBOL: Record<string, string> = {
  USD: '$', EUR: '€', GBP: '£', INR: '₹', JPY: '¥', CHF: 'CHF',
  CAD: 'CA$', AUD: 'A$', CNY: 'CN¥', SEK: 'kr', NOK: 'kr', DKK: 'kr', PLN: 'zł',
};

export function currencySymbol(code?: string | null): string {
  const c = String(code || '').trim().toUpperCase();
  if (!c) return '';
  // An unmapped code renders as "XYZ 1,234.50" — unambiguous rather than mislabelled.
  return CURRENCY_SYMBOL[c] || `${c} `;
}

/** "$1,234.50" — full precision, for figures a user might reconcile against. */
export function money(n: number | null | undefined, code?: string | null): string {
  if (n == null) return '—';
  return `${currencySymbol(code)}${Number(n).toLocaleString('en-GB', {
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  })}`;
}

/** "$1,235" — rounded, for headline tiles where pennies are noise. */
export function moneyRound(n: number | null | undefined, code?: string | null): string {
  if (n == null) return '—';
  return `${currencySymbol(code)}${Math.round(Number(n)).toLocaleString('en-GB')}`;
}
